'use strict';
Object.defineProperty(exports, "__esModule", { value: true });
exports.Hamburger = void 0;
var $ = require("jquery");
var Hamburger = /** @class */ (function () {
    function Hamburger() {
        var _this = this;
        $('.trigHamburger').on('click', function () {
            var bulletNavi = $('#bulletNavi');
            bulletNavi.toggleClass('open');
            if (bulletNavi.hasClass('open')) {
                $('.bulletHamburger').addClass('active');
                $('.bulletHamburgerCatchCopy').attr('data-open', 1);
                if ($('.paramScrollDisplay').attr('data-scroll') === '0') {
                    $('.bulletHamburgerCatchCopy').fadeOut('slow');
                }
            }
            else {
                _this.close();
            }
        });
        $('.trigCloseNavi').on('click', function () {
            var bulletNavi = $('#bulletNavi');
            if (bulletNavi.hasClass('open')) {
                _this.close();
                bulletNavi.removeClass('open');
            }
        });
    }
    Hamburger.prototype.close = function () {
        $('.bulletHamburger').removeClass('active');
        $('.bulletHamburgerCatchCopy').attr('data-open', 0);
        if ($('.paramScrollDisplay').attr('data-scroll') === '0') {
            $('.bulletHamburgerCatchCopy').fadeIn('slow');
        }
    };
    return Hamburger;
}());
exports.Hamburger = Hamburger;
exports.default = Hamburger;
